// BHP-1070: customer domain model for the sign-up onboarding create-flow.
// Only the fields the onboarding form needs; the full CreateCustomerDto has many
// optional fields we do not collect during onboarding.

export type CustomerType = 'customer' | 'business' | 'reseller';

export const CUSTOMER_TYPES: readonly CustomerType[] = [
  'customer',
  'business',
  'reseller'
];

/** Input for POST /api/customers (subset of CreateCustomerDto). */
export interface NewCustomer {
  phoneNumber: string;
  email: string;
  administrationFirstName: string;
  administrationLastName: string;
  type: CustomerType;
  companyName?: string;
}

/** Normalized customer as returned by Backend2.0. */
export interface Customer {
  uuid: string;
  type: string;
  companyName: string | null;
  email: string;
  phoneNumber: string;
  administrationFullName: string;
}
